import { Delete, Get, Post, PostFormData, Put } from "../Request/Api";

export default {
  state: {
    coordinator: null,
    instructors: [],
    archiveInstructors: [],
    instructorCordinators: [],
    inviteCoordinator: null,
    PreviewCoordinator: null,
    SeminarByCoordinatorId: [],
    seminarItemsPerPage: null,
  },
  getters: {
    GetInstructor(state: any) {
      return state.coordinator;
    },
    Intructors(state: any) {
      return state.instructors;
    },
    archiveInstructors(state: any) {
      return state.archiveInstructors;
    },
    GetInvitation(state: any) {
      return state.inviteCoordinator;
    },
    GetPreviewcoordinator(state: any) {
      return state.inviteCoordinator;
    },
    GetInstructorCoordinators(state: any) {
      return state.instructorCordinators;
    },
    GetAllSeminarByCoordinatorId(state: any) {
      return state.SeminarByCoordinatorId;
    },
  },
  actions: {
    async GetInstructorCoordinator({ commit }: any, payload: any) {
      return await Get(`User/GetInstructorCoordinator?Id=${payload}`).then(
        (res: any) => {
          commit("SetCoordinator", res.data.Data);

          return res.data;
        }
      );
    },
    async GetAllSeminarByCoordinatorId({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetAllSeminarByCoordinatorId?coordinatorId=${payload.id}&page=${payload.page}&pageSize=${payload.pagesize}&search=${payload.search}&filters=${payload.filter}`
      ).then((res: any) => {
        commit("SetAllSeminarByCoordinatorId", res.data.Data.List);

        return res.data;
      });
    },

    async AcceptRejectInstructorCoordinator({ commit }: any, payload: any) {
      return await Put(`User/AcceptRejectInstructorCoordinator`, payload).then(
        (res: any) => {
          commit("SetCoordinatorss", res.data.Data);

          return res.data;
        }
      );
    },
    async UnArchiveInstructorCoordinator({ commit }: any, payload: any) {
      return await Put(
        `Coordinator/UnArchivedInstructorCoordinator?Id=${payload}`,
        payload
      ).then((res: any) => {
        return res.data;
      });
    },
    async RemoveInstructorCoordinator({ commit }: any, payload: any) {
      return await Delete(
        `Coordinator/RemoveInstructorCoordinator?Id=${payload.Id}`
      ).then((res: any) => {
        return res.data;
      });
    },
    async AddInstructorInviteCoordinatorr({ commit }: any, payload: any) {
      return await Post(`Coordinator/AddInstructorCoordinator`, payload).then(
        (res: any) => {
          commit("SetCoordinatorInvite", res.data.Data);
          return res.data;
        }
      );
    },
    async AgreementCodeOfEthics({ commit }: any, payload: any) {
      return await Put(
        `Coordinator/AcceptIBACoordinatorAgreement`,
        payload
      ).then((res: any) => {
        commit("SetAgreement", res.data.Data);
        return res.data;
      });
    },
    // async GetInstructors({ commit }: any, payload: any) {
    //   return await Get(
    //     `User/GetInstructors`
    //   ).then((res: any) => {
    //     commit("SetInstructors", res.data.Data);

    //     return res.data;
    //   });
    // },
    async GetAllInstructors({ commit }: any, payload: any) {
      console.log(typeof payload.pageSize);
      return await Get(
        `Coordinator/GetInstructorCoordinatorsByInstructorId/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&instructorId=${payload.instructorId}`
      ).then((res: any) => {
        commit("SetInstructors", res.data.Data.List);
        return res.data.Data;
      });
    },
    async GetInstructorCoordinators({ commit }: any, payload: any) {
      return await Get(
        `Coordinator/GetInstructorCoordinatorsByCoordinatorId?coordinatorId=${payload.instructorId}`
      ).then((res: any) => {
        commit("SetInstructorCordinators", res.data.Data);
        return res.data.Data;
      });
    },
    async GetAllArchiveInstructors({ commit }: any, payload: any) {
      return await Get(
        `Coordinator/GetArchivedInstructorCoordinatorsByInstructorId/?page=${payload.page}&search=${payload.search}&pageSize=${payload.pageSize}&instructorId=${payload.instructorId}`
      ).then((res: any) => {
        commit("SetArchiveInstructors", res.data.Data.List);

        return res.data.Data;
      });
    },
    async updateCoordinatoreprefrence({ commit }: any, payload: any) {
      return await Put(
        `Coordinator/UpdateInstructorCoordinatorPreference`,
        payload
      ).then((res: any) => {
        return res.data.Data;
      });
    },

    async PreviewCooridnatore({ commit }: any, payload: any) {
      return await Get(
        `Coordinator/GetInstructorCoordinatorsByCoordinatorId?coordinatorId=10026`
      ).then((res) => {
        commit("SetPreviewCoordinator", res.data);

        return res.data;
      });
    },

    async AddInstructorCoordinator({ commit }: any, payload: any) {
      return await Post(`User/AddInstructorCoordinator`, payload).then(
        (res: any) => {
          commit("SetCoordinatorInvite", res.data.Data);

          return res.data;
        }
      );
    },
    async GetInstructors({ commit }: any, payload: any) {
      return await Get(`User/GetInstructors`).then((res: any) => {
        commit("SetInstructors", res.data.Data);

        return res.data;
      });
    },
  },
  mutations: {
    SetAllSeminarByCoordinatorId(state: any, payload: any) {
      state.SeminarByCoordinatorId = payload;
    },
    SetPreviewCoordinator(state: any, payload: any) {
      state.PreviewCoordinator = payload;
    },
    SetCoordinator(state: any, payload: any) {
      state.coordinator = payload;
    },
    SetInstructorCordinators(state: any, payload: any) {
      state.instructorCordinators = payload;
    },
    SetCoordinatorInvite(state: any, payload: any) {},
    SetInstructors(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.ProfileImage =
          x?.ProfileImage != null &&
          x?.ProfileImage != undefined &&
          x?.ProfileImage != ""
            ?  x?.ProfileImage
            // ? process.env.VUE_APP_IMG_URL + x?.ProfileImage
            : "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&w=1000&q=80";
        return x;
      });
      payload = payload.sort((a:any, b:any) => {
        if (a.Coordinator?.LastName && b.Coordinator?.LastName) {
          const lastNameA = a.Coordinator.LastName.toLowerCase();
          const lastNameB = b.Coordinator.LastName.toLowerCase();
      
          if (lastNameA < lastNameB) return -1;
          if (lastNameA > lastNameB) return 1;
        }
        
        if (!a.Coordinator?.LastName) return 1;
        if (!b.Coordinator?.LastName) return -1;
      
        return 0;
      });
      payload.forEach((item:any) => {
        item.Coordinator.fullName = `${item.Coordinator.FirstName} ${item.Coordinator.LastName}`
      });
      state.instructors = payload;
    },
    SetArchiveInstructors(state: any, payload: any) {
      payload = payload.map((x: any) => {
        x.ProfileImage =
          x?.ProfileImage != null &&
          x?.ProfileImage != undefined &&
          x?.ProfileImage != ""
            // ? process.env.VUE_APP_IMG_URL + x?.ProfileImage
            ? x?.ProfileImage
            : "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&w=1000&q=80";
        return x;
      });
      state.archiveInstructors = payload;
    },
  },
};
